import React, { FC, useState } from 'react';
import styles from './styles.module.css';
import { Asset } from '../../../Shared/components/Asset';

const STORAGE_KEY = 'outdated-browser-dismissed';

const isIE11 = () => !!window.MSInputMethodContext && !!document.documentMode;

export const OutdatedBrowserMessage: FC = () => {
  const [dismissed, changeDismissed] = useState(false);

  if (dismissed || !isIE11() || localStorage.getItem(STORAGE_KEY)) {
    return null;
  }

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    changeDismissed(true);
  };

  return (
    <div className={styles.container}>
      <div className={styles.copy}>
        The internet browser you're using is out of date. For the best
        experience, we recommend a modern browser like Chrome or Firefox.
      </div>
      <div className={styles.close} onClick={dismiss}>
        <Asset variant="close" />
      </div>
    </div>
  );
};
